import { CloudinaryImage } from '#src/components/CloudinaryImage';
import { formatGameDateRange } from '#src/lib/formatters/temporal';

import Total from '../Total';

import styles from './styles.module.scss';

const GameItem = ({ amountDue, game }) => {
  const { image, title } = game;
  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <CloudinaryImage image={image} crop="fill" width={50} height={50} />
      </div>
      <div className={styles.detailsContainer}>
        <h4 className={styles.title}>{title}</h4>
        <div className={styles.date}>
          <span>{formatGameDateRange(game)}</span>
        </div>
      </div>
      <Total amountDue={amountDue} />
    </div>
  );
};

export default GameItem;
